var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.infos),function(info){return _c('div',{key:info.type,class:info.type},[_c('svg',[_c('use',{attrs:{"xlink:href":`#icon-${info.icon}`}})]),_vm._v(" "),(info.type !== 'electric')?_c('span',{staticClass:"info-type"},[_vm._v(_vm._s(info.val))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }